<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="mx-2">


            <v-data-table
                    :headers="headers"
                    :items="this.redeemPoints"
                    hide-actions
                    hide-headers>
                <template slot="items" slot-scope="props">
                        <v-layout class="ml-5 mt-2" row @click="openDialog(props.item.books[0].book)">

                            <v-icon left>library_books</v-icon>
                            <v-layout row>
                                    <a class="mt-2">
                                        <u>
                                        {{props.item.books[0].book.title}}
                                        </u>
                                    </a>
                                    <!----------------------Tooltips-------------------------------------------------------->

                                    <ToolTipComponent class="ml-2" v-if="util.checkToolTipId(props.item.books[0].book.id)" :bookId="props.item.books[0].book.id"/>
                            </v-layout>
                                    <!----------------------Tooltips-------------------------------------------------------->




                            <!--<v-chip @click="openDialog(props.item.books[0].book)" class="pa-1 ma-3" color="primary"-->
                                    <!--outline>-->
                                <!--<v-icon left>library_books</v-icon>-->
                                <!--{{props.item.books[0].book.title}}-->
                            <!--</v-chip>-->

                            <!----------------------Tooltips-------------------------------------------------------->

                            <!--<ToolTipComponent class="mt-3" v-if="util.checkToolTipId(props.item.books[0].book.id)" :bookId="props.item.books[0].book.id"/>-->

                            <!----------------------Tooltips-------------------------------------------------------->

                        </v-layout>

                </template>
            </v-data-table>

    </div>

</template>

<script>

    import util from "../../utilities"
    import ToolTipComponent from "./ToolTipComponent";


    export default {
        name: "RedeemBooksComponent",
        components: {ToolTipComponent},
        data(){
            return {
                util,
                redeemPoints: [],
                headers: [
                    {
                        text: 'Βιβλία απο εξαργύρωση',
                        align: 'left',
                        sortable: false,
                        value: 'name'
                    }
                ],
                desserts: [
                    {
                        name: 'Frozen Yogurt'

                    },
                    {
                        name: 'Ice cream sandwich'

                    }
                ]
            }
        },
        methods: {
            openDialog(book) {
                this.$store.commit('setBookInfoModal', book);
                this.$store.commit('setDialog', true)
            },
            closeDialog() {
                this.$store.commit('setDialog', true)
            },
        //    $store.getters.redeemPoints
            redeemPointsToArray(){
                var redeem = this.$store.getters.redeemPoints;
                for(var redeemPoint in  redeem){
                    this.redeemPoints.push(redeem[redeemPoint].books);
                }
            }
        },
        created() {
            this.redeemPointsToArray();
        }
    }
</script>

<style scoped>

</style>